import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-licenses-licenses-dashboard',
    templateUrl: './licenses-licenses-dashboard.component.html',
    styleUrls: ['./licenses-licenses-dashboard.component.scss'],
    standalone: false
})
export class LicensesLicensesDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
